import { render } from "./CadastroTipoPessoasView.vue?vue&type=template&id=3366d7cd"
import script from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__